import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './withRightStoreLocator.module.scss';

const HeaderWithRightStoreLocatorDesktop = () => (
  <>
    <HeaderRow
      borderless
      className={styles.search__header_center_row}
      type="medium"
    >
      <HeaderSection justify="start">
        <HeaderLogo fixHeight fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <MedRecSwitch />
        <StoreLocator />
        <SearchHeader withEmbeddedInput />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="flat" withNavbar>
      <HeaderSection justify="start">
        <HeaderNav />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithRightStoreLocatorDesktop };
